import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	headline: {
		marginBottom: theme.spacing(4)
	},
	container: {
		display: "grid",
		gridColumnGap: theme.spacing(2),
		gridRowGap: theme.spacing(3),
		gridTemplateColumns: "1fr 1fr",
		gridTemplateRows: "auto",
		[theme.breakpoints.up("sm")]: {
			gridTemplateColumns: "1fr 1fr 1fr"
		},
		[theme.breakpoints.up("md")]: {
			gridColumnGap: theme.spacing(4),
			gridRowGap: theme.spacing(5),
			gridTemplateColumns: "1fr 1fr 1fr 1fr"
		}
	}
}));

export default styles;
